module.exports = __webpack_public_path__ + "assets/img/6@3x.0bd72804.png";